import React, { Component } from "react";

export default class chevron extends Component {
  render() {
    return (
      <svg
        className={this.props.className}
        onClick={this.props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke="#73706E"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
